import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController } from 'ionic-angular';
import { AngularFire, FirebaseListObservable } from 'angularfire2';

import Quill from 'quill';
import moment from 'moment';

@Component({
  selector: 'page-value',
  templateUrl: 'value.html'
})
export class Value {

  // Loader
  loader: any = null;

  // Editors
  quill_en: any = null;
  quill_trm: any = null;

  // Data
  segmentModel: string = 'English';
  valueModel: any = {};
  editFlag: boolean = false;
  values: FirebaseListObservable<any[]>;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public af: AngularFire) {
    
    this.valueModel = JSON.parse(JSON.stringify( navParams.get('value') ));
    this.editFlag = navParams.get('edit');

    this.values = this.af.database.list(`/values`);
  }

  ionViewDidLoad() {
    let options: any = {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline']
        ]
      },
      placeholder: 'Enter description',
      theme: 'snow'  // or 'bubble'
    };

    this.quill_en = new Quill('#editor_en', options);
    this.quill_trm = new Quill('#editor_trm', options);

    console.log('ionViewDidLoad - quill', this.quill_en, this.quill_trm);
  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  dismiss() {
    this.dismissLoader();
    
    setTimeout(() => {
      this.viewCtrl.dismiss();
    }, 400);
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      dismissOnPageChange: true
    });
    this.loader.present();
  }

  validFields() {
    try {
      for (var key in this.valueModel) {

        console.log('validFields - data', key, this.valueModel[key], typeof this.valueModel[key]);

        if (key !== 'timestamp' 
          && key !== 'id'
          && key !== '$key'
          && key !== '$exists'
          && key !== 'title_trm'
          && key !== 'description_trm'
          && (typeof(this.valueModel[key]) !== "boolean") 
          && (typeof(this.valueModel[key]) !== "object")
          && !(this.valueModel[key] instanceof Array) ) {

          if (this.valueModel[key] === null || this.valueModel[key].trim() == null
            || this.valueModel[key].trim() == "" || this.valueModel[key] === " " || this.valueModel[key] === "  ") {
            return false;
          }

        }
      }
      return true;
    } catch (err) {
      console.log('Value - validFields', err);
    }
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: 'Harmonised',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  onClose() {
    this.dismiss();
  }

  deleteValue() {
    try{
      console.log('saveValue', this.valueModel);
      this.presentLoading();
      if (this.valueModel.id) {
        this.values.remove(this.valueModel.id);
      }

      setTimeout( () => {
        this.dismiss();
      }, 600 );
    } catch (error) {
      console.log('deleteValue', error);
    }
  }

  saveValue() {
    try{
      this.presentLoading();

      this.valueModel.description_en = this.quill_en.root.innerHTML;
      this.valueModel.description_trm = this.quill_trm.root.innerHTML;

      console.log('saveValue', this.editFlag, this.valueModel);

      if (!this.validFields()) {
        this.showMsg('Please, fill the form correctly.');
        return;
      }
  
      // (<any>firebase).database.ServerValue.TIMESTAMP
      let tmpModel: any = {
        title_en: this.valueModel.title_en,
        description_en: this.valueModel.description_en,
        title_trm: this.valueModel.title_trm || '',
        description_trm: this.valueModel.description_trm || '',
        timestamp: moment().unix()
      };

      if (this.editFlag) {
        this.values.update(this.valueModel.id, tmpModel);
      } else {
        this.values.push(tmpModel);
      }
      this.dismiss();
    } catch (error) {
      console.log('saveValue', error);
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/value/value.ts